import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import useCreateDailyFormVehicle from "hooks/fleet/useCreateDailyFormVehicle";
import VehicleForm, { VehicleFormData } from "components/fleet/VehicleForm";

export default function CreateVehiclePage() {
  const navigate = useNavigate();
  const [createVehicle, { loading: creating }] = useCreateDailyFormVehicle();

  const onSubmit = useCallback(
    async (data: VehicleFormData) => {
      const input = {
        name: data.name,
        dailyFormVehicleTypeId: data.dailyFormVehicleTypeId,
        year: data.year,
        make: data.make || null,
        model: data.model || null,
        vin: data.vin || null,
        licensePlate: data.licensePlate || null,
        registrationState: data.registrationState || null,
        registrationExpirationDate: data.registrationExpirationDate || null,
        inServiceDate: data.inServiceDate || null,
        meterType: data.meterType || null,
        currentMeterReading: data.currentMeterReading ?? null,
        defaultServiceIntervalValue: data.defaultServiceIntervalValue ?? null,
        defaultServiceIntervalUnit: data.defaultServiceIntervalUnit || null,
        notes: data.notes || null,
        isActive: data.isActive,
      };

      const result = await createVehicle({
        variables: {
          input,
        },
      });

      if (result && !result.errors) {
        navigate("/fleet/fleet-settings");
      }
    },
    [createVehicle, navigate]
  );

  const handleCancel = () => {
    navigate("/fleet/fleet-settings");
  };

  return (
    <DashboardPage>
      <VehicleForm
        mode="create"
        onSubmit={onSubmit}
        loading={creating}
        onCancel={handleCancel}
        title="Create New Vehicle"
        submitButtonText="Create Vehicle"
      />
    </DashboardPage>
  );
}
